export default function Operations() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 font-['Montserrat']">
            Raw Material Suppliers
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Strategic sourcing and supply chain management
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/4874e812f0ccb3337c16076c08c93d36.jpg"
                alt="Chrome Ore Mining Operations"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#8B1538] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2 text-gray-900 font-['Montserrat']">
                    Multiple Mine Sources
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Currently, TMI is buying raw material from various mines located 70 to 120km away from the plant. This diversified sourcing strategy ensures consistent supply and reduces dependency on single sources.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-700 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-recycle-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2 text-gray-900 font-['Montserrat']">
                    Tailings Reprocessing
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    TMI also buys tailings from other plants and reprocesses them, maximizing resource utilization and contributing to sustainable mining practices.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#8B1538] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-truck-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-2 text-gray-900 font-['Montserrat']">
                    Exclusive Offtake Agreement
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    TMI is in the process of finalizing an exclusive offtake with a local community for a dump left by old mining operations. TMI plans to place yellow machines on the dump site to prepare raw material before trucking it to the processing site, ensuring consistency and wide options in feed supplies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Management Team Section */}
        <div className="bg-gradient-to-br from-red-50 to-gray-50 p-12 rounded-lg">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900 font-['Montserrat']">
              Management Team
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Expertise that drives our success
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#8B1538] rounded-full flex items-center justify-center mb-6">
                <i className="ri-user-star-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-900 font-['Montserrat']">
                Combined 40+ Years Experience
              </h3>
              <p className="text-gray-700 leading-relaxed text-sm">
                The TMI team consists of individuals with combined over 40 years of experience, ranging from legal, mining, property, financial sector, marketing and sales, as well as engineering.
              </p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-gray-700 rounded-full flex items-center justify-center mb-6">
                <i className="ri-group-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-900 font-['Montserrat']">
                Strategic Partnerships
              </h3>
              <p className="text-gray-700 leading-relaxed text-sm">
                Over and above the management team, TMI has strategic partnerships in place to compensate skills that are not in the company, such as research specialists, ensuring comprehensive expertise across all areas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
